// extracted by mini-css-extract-plugin
export default {"productDescription":"Z_-z","featuredDescription":"__-z","description":"aaa-z","more":"baa-z","descriptionSku":"caa-z"};